import { Action } from '@ngrx/store';
import { IOption } from '@shared/interfaces/selectable-options.interfaces';

// TODO refactor to use createAction()

export enum AuthActionTypes {
	LOGIN = '[Auth] Login',
	LOGIN_SUCCESS = '[Auth] Login Success',
	LOGIN_FAILURE = '[Auth] Login Failure',
	SIGNUP = '[Auth] Signup',
	SIGNUP_SUCCESS = '[Auth] Signup Success',
	SIGNUP_FAILURE = '[Auth] Signup Failure',
	LOGOUT = '[Auth] Logout',
	GET_STATUS = '[Auth] GetStatus',
	UPDATE_CURRENT_USER = '[Auth] Current user data updated',
	CURRENT_USER_SUCCESS = '[Auth] Current User Success',
	CURRENT_USER_FAILURE = '[Auth] Current User Failure',
	PASSWORD_RESET = '[Auth] Password Reset',
	PASSWORD_RESET_SUCCESS = '[Auth] Password Reset Success',
	PASSWORD_RESET_FAILURE = '[Auth] Password Reset Failure',
	PASSWORD_RESET_EMAIL_SENT = '[Auth] Password Reset Email Sent',
	SET_NEW_PASSWORD = '[Auth] Set New Password',
	LOAD_AUTH_TRANSLATE = '[Auth] Load Auth Translate',
	LOAD_AUTH_TRANSLATE_SUCCESS = '[Auth] Load Auth Translate Success',
	LOAD_AUTH_TRANSLATE_FAILURE = '[Auth] Load Auth Translate Failure',
	SEND_NEW_PASSWORD = '[Auth] Send New Password',
	SEND_NEW_PASSWORD_SUCCESS = '[Auth] Send New Password Success',
	SEND_NEW_PASSWORD_FAILURE = '[Auth] Send New Password Failure',
	SET_USER_PASSWORD = '[Auth] Set user password',
	SET_USER_PASSWORD_SUCCESS = '[Auth] Set user password Success',
	SET_USER_PASSWORD_FAILURE = '[Auth] Set user password Failure',
	UPDATE_FOLLOWED_BUILDINGS = '[Auth] Update Followed Buildings',
	UPDATE_FOLLOWED_BUILDINGS_SUCCESS = '[Auth] Update Followed Buildings success',
	UNFOLLOW_BUILDING = '[Auth] Unfollow selected building',
	UNFOLLOW_BUILDING_SUCCESS = '[Auth] Unfollow selected building success',
}

export class LogIn implements Action {
	readonly type = AuthActionTypes.LOGIN;

	constructor(public payload: any) {}
}

export class LogInSuccess implements Action {
	readonly type = AuthActionTypes.LOGIN_SUCCESS;

	constructor(public payload: any) {}
}

export class LogInFailure implements Action {
	readonly type = AuthActionTypes.LOGIN_FAILURE;
}

export class SignUp implements Action {
	readonly type = AuthActionTypes.SIGNUP;

	constructor(public payload: any) {}
}

export class SignUpSuccess implements Action {
	readonly type = AuthActionTypes.SIGNUP_SUCCESS;

	constructor(public payload: any) {}
}

export class SignUpFailure implements Action {
	readonly type = AuthActionTypes.SIGNUP_FAILURE;

	constructor(public payload: any) {}
}

export class LogOut implements Action {
	readonly type = AuthActionTypes.LOGOUT;
}

export class GetStatus implements Action {
	readonly type = AuthActionTypes.GET_STATUS;
}

export class UpdateCurrentUser implements Action {
	readonly type = AuthActionTypes.UPDATE_CURRENT_USER;

	constructor(public payload: any) {}
}

export class CurrentUserSuccess implements Action {
	readonly type = AuthActionTypes.CURRENT_USER_SUCCESS;

	constructor(public payload: any) {}
}

export class CurrentUserFailure implements Action {
	readonly type = AuthActionTypes.CURRENT_USER_FAILURE;

	constructor(public payload: any) {}
}

export class PasswordReset implements Action {
	readonly type = AuthActionTypes.PASSWORD_RESET;

	constructor(public payload: any) {}
}

export class PasswordResetSuccess implements Action {
	readonly type = AuthActionTypes.PASSWORD_RESET_SUCCESS;
}

export class PasswordResetEmailSent implements Action {
	readonly type = AuthActionTypes.PASSWORD_RESET_EMAIL_SENT;
}

export class PasswordResetFailure implements Action {
	readonly type = AuthActionTypes.PASSWORD_RESET_FAILURE;

	constructor(public payload: any) {}
}

export class SetNewPassword implements Action {
	readonly type = AuthActionTypes.SET_NEW_PASSWORD;

	constructor(public payload: any) {}
}

export class LoadAuthTranslate implements Action {
	readonly type = AuthActionTypes.LOAD_AUTH_TRANSLATE;

	constructor(public payload: any) {}
}

export class LoadAuthTranslateSuccess implements Action {
	readonly type = AuthActionTypes.LOAD_AUTH_TRANSLATE_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadAuthTranslateFailure implements Action {
	readonly type = AuthActionTypes.LOAD_AUTH_TRANSLATE_FAILURE;

	constructor(public payload: any) {}
}

export class SendNewPassword implements Action {
	readonly type = AuthActionTypes.SEND_NEW_PASSWORD;

	constructor(public payload: any) {}
}

export class SendNewPasswordSuccess implements Action {
	readonly type = AuthActionTypes.SEND_NEW_PASSWORD_SUCCESS;

	constructor(public payload: any) {}
}

export class SendNewPasswordFailure implements Action {
	readonly type = AuthActionTypes.SEND_NEW_PASSWORD_FAILURE;

	constructor(public payload: any) {}
}

export class SetUserPassword implements Action {
	readonly type = AuthActionTypes.SET_USER_PASSWORD;

	constructor(public payload: any) {}
}

export class SetUserPasswordSuccess implements Action {
	readonly type = AuthActionTypes.SET_USER_PASSWORD_SUCCESS;

	constructor(public payload: any) {}
}

export class SetUserPasswordFailure implements Action {
	readonly type = AuthActionTypes.SET_USER_PASSWORD_FAILURE;

	constructor(public payload: any) {}
}

export class UpdateFollowedBuildings implements Action {
	readonly type = AuthActionTypes.UPDATE_FOLLOWED_BUILDINGS;

	constructor(public payload: IOption) {}
}

export class UpdateFollowedBuildingsSuccess implements Action {
	readonly type = AuthActionTypes.UPDATE_FOLLOWED_BUILDINGS_SUCCESS;

	constructor(public payload: IOption[]) {}
}

export class UnfollowBuilding implements Action {
	readonly type = AuthActionTypes.UNFOLLOW_BUILDING;

	constructor(public payload: string) {}
}

export class UnfollowBuildingSuccess implements Action {
	readonly type = AuthActionTypes.UNFOLLOW_BUILDING_SUCCESS;

	constructor(public payload: IOption[]) {}
}

export type AuthActions =
	| LogIn
	| LogInSuccess
	| LogInFailure
	| SignUp
	| SignUpSuccess
	| SignUpFailure
	| LogOut
	| GetStatus
	| UpdateCurrentUser
	| CurrentUserSuccess
	| CurrentUserFailure
	| PasswordReset
	| PasswordResetSuccess
	| PasswordResetEmailSent
	| PasswordResetFailure
	| SetNewPassword
	| LoadAuthTranslate
	| LoadAuthTranslateSuccess
	| LoadAuthTranslateFailure
	| SendNewPassword
	| SendNewPasswordSuccess
	| SendNewPasswordFailure
	| SetUserPassword
	| SetUserPasswordSuccess
	| SetUserPasswordFailure
	| UpdateFollowedBuildingsSuccess
	| UnfollowBuilding
	| UnfollowBuildingSuccess;
